import { Languages, SearchableStatisticInstantSearch } from '@livv/models';
import { getStatisticLink } from '@livv/utils/helpers';
import { fromUnixTime } from 'date-fns';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import ContentCard, { PreviewCardProps } from './ContentCard';
import { useFreemiumDialog } from '@utils/context/freemiumDialog';
import { getDate } from '@utils/date';

type StatisticPreviewProps = PreviewCardProps<SearchableStatisticInstantSearch>;

const StatisticPreview: FC<StatisticPreviewProps> = ({ hit }) => {
    const { baseObjectID, createdAt, category } = hit;
    const { t, lang } = useTranslation('article');
    const { openFreemiumDialog } = useFreemiumDialog();

    const href = getStatisticLink(baseObjectID);

    return (
        <ContentCard
            hit={hit}
            href={href}
            onClick={openFreemiumDialog}
            secondaryAttributes={[
                {
                    attribute: getDate(fromUnixTime(createdAt), lang as Languages),
                    label: t('publishedAt'),
                },
            ]}
            tags={category ? [category] : []}
            titleAttribute="title"
        />
    );
};

export default StatisticPreview;
